import { InfoIcon } from 'components/svgs';
import Tooltip from 'components/tooltip/Tooltip';
import { ItineraryVersion } from 'core/graphql/types';
import { format, parseISO } from 'date-fns';

export interface ItineraryVersionItemProps {
  itineraryVersion: ItineraryVersion;
  selectedItineraryId: any;
  itineraryVersionClickHandler: (id: any) => void;
}

const ItineraryVersionItem = ({
  itineraryVersion,
  selectedItineraryId,
  itineraryVersionClickHandler,
}: ItineraryVersionItemProps) => {
  const nonGeocodedStops =
    itineraryVersion.itineraryStops.filter(
      (stop) => stop.latitude == null && stop.longitude == null,
    ).length ?? 0;
  return (
    <li
      key={itineraryVersion.id}
      className="my-2 hover:outline hover:outline-1 hover:outline-design-red"
    >
      <button
        type="button"
        className="w-full"
        onClick={() => itineraryVersionClickHandler(itineraryVersion.id)}
      >
        <div
          className={`flex justify-center p-2 ${
            selectedItineraryId === itineraryVersion.id
              ? 'outline outline-1 outline-red'
              : 'bg-muted-white dark:bg-design-secondary-black'
          }`}
        >
          <span className="px-2 dark:text-white">
            {itineraryVersion.isCourierOrder
              ? 'Courier generated'
              : 'System generated'}
          </span>
          <span className="font-semibold">
            {`${format(parseISO(itineraryVersion.createdDate), 'HH:mm')} - ${
              itineraryVersion.itineraryStops.length
            } stops`}
          </span>
          {itineraryVersion.isLateRefill && (
            <div className=" ml-2 inline-flex items-center rounded-md bg-red px-2.5 py-0.5 text-xs font-semibold">
              Late Refill
            </div>
          )}
          {nonGeocodedStops > 0 && (
            <span className="mx-2 flex items-center px-1 text-xs">
              <Tooltip text={`Non-geocoded stops ${nonGeocodedStops}`}>
                <InfoIcon className="dark:fill-white" />
              </Tooltip>
            </span>
          )}
        </div>
      </button>
    </li>
  );
};

export default ItineraryVersionItem;
